import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_resource_properties_edit_component = _resolveComponent("resource-properties-edit-component")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_resource_preview_dialog = _resolveComponent("resource-preview-dialog")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialog) = $event)),
    onKeydown: _withKeys(_ctx.resolveCancel, ["esc"]),
    scrollable: "",
    "max-width": "85vw"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { height: "85vh" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, { color: "surface-variant" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.title ?? _ctx.$t('admin-resources.resourceLookup')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_text, { class: "pa-4" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", { innerHTML: _ctx.message }, null, 8 /* PROPS */, _hoisted_1), [
                [_vShow, !!_ctx.message]
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_v_data_table_server, {
                  "sort-by": [{ key: 'createdTimestamp', order: 'desc' }],
                  "item-value": "uuid",
                  "show-select": "",
                  "select-strategy": "single",
                  modelValue: _ctx.selectedResource,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedResource) = $event)),
                  headers: _ctx.headers,
                  items: _ctx.resources,
                  options: _ctx.resourcesTableOptions,
                  "onUpdate:options": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.resourcesTableOptions) = $event)),
                  "items-length": _ctx.totalResources,
                  loading: _ctx.loading,
                  "items-per-page-options": [10, 20, 30],
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createCommentVNode(" Saved filters dialog "),
                    _createVNode(_component_v_dialog, {
                      modelValue: _ctx.savedFiltersDialog,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.savedFiltersDialog) = $event)),
                      "max-width": "600px",
                      scrollable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_toolbar, {
                              color: "surface-variant",
                              density: "compact"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_toolbar_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.savedFilters')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  icon: "",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.savedFiltersDialog = false))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                        _createTextVNode("mdi-close", -1 /* CACHED */)
                                      ]))]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_card_text, {
                              class: "pa-3 pb-0",
                              style: {"flex-shrink":"0"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_alert, {
                                  type: "info",
                                  variant: "tonal",
                                  density: "compact",
                                  class: "mb-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.savedFilters.overwriteWarning')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.savedFiltersSearch,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.savedFiltersSearch) = $event)),
                                  clearable: "",
                                  "hide-details": "",
                                  density: "compact",
                                  "prepend-inner-icon": "mdi-magnify",
                                  label: _ctx.$t('admin-resources.filter.savedFilters.search')
                                }, null, 8 /* PROPS */, ["modelValue", "label"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_list, { style: {"max-height":"400px","overflow-y":"auto"} }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMenuFilters, (filter) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: filter.filterId?.id,
                                    lines: "two"
                                  }, {
                                    title: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(filter.filterName), 1 /* TEXT */)
                                    ]),
                                    subtitle: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(filter.filterDescription), 1 /* TEXT */)
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_tooltip, {
                                        text: _ctx.$t('admin-resources.filter.savedFilters.chooseFilter'),
                                        location: "top"
                                      }, {
                                        activator: _withCtx(({ props: tooltipProps }) => [
                                          _createVNode(_component_v_btn, _mergeProps({
                                            icon: "",
                                            variant: "text"
                                          }, { ref_for: true }, tooltipProps, {
                                            onClick: ($event: any) => (_ctx.applySavedFilter(filter))
                                          }), {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                  _createTextVNode("mdi-filter-check", -1 /* CACHED */)
                                                ]))]),
                                                _: 1 /* STABLE */
                                              })
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 16 /* FULL_PROPS */, ["onClick"])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                }), 128 /* KEYED_FRAGMENT */)),
                                (_ctx.filteredMenuFilters.length === 0)
                                  ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, { class: "text-medium-emphasis" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.savedFilters.noFilters')), 1 /* TEXT */)
                                          ]),
                                          _: 1 /* STABLE */
                                        })
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_card_actions, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  variant: "outlined",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.savedFiltersDialog = false))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('confirm-dialog.cancel')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"]),
                    _createElementVNode("form", null, [
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.resourceListFilter.data.uuid,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.resourceListFilter.data.uuid) = $event)),
                                    clearable: "",
                                    "hide-details": "",
                                    density: "compact",
                                    label: _ctx.$t('admin-resources.filter.uuid')
                                  }, null, 8 /* PROPS */, ["modelValue", "label"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.resourceListFilter.data.resourceName,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.resourceListFilter.data.resourceName) = $event)),
                                    clearable: "",
                                    "hide-details": "",
                                    density: "compact",
                                    label: _ctx.$t('admin-resources.filter.name')
                                  }, null, 8 /* PROPS */, ["modelValue", "label"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.resourceListFilter.data.resourceExternalId,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.resourceListFilter.data.resourceExternalId) = $event)),
                                    clearable: "",
                                    "hide-details": "",
                                    density: "compact",
                                    label: _ctx.$t('admin-resources.filter.externalId')
                                  }, null, 8 /* PROPS */, ["modelValue", "label"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.resourceListFilter.data.resourceStatus,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.resourceListFilter.data.resourceStatus) = $event)),
                                    clearable: "",
                                    "hide-details": "",
                                    density: "compact",
                                    items: _ctx.statusOptions,
                                    label: _ctx.$t('admin-resources.filter.status')
                                  }, null, 8 /* PROPS */, ["modelValue", "items", "label"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.resourceListFilter.data.resourceType,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resourceListFilter.data.resourceType) = $event)),
                                    clearable: "",
                                    "hide-details": "",
                                    density: "compact",
                                    items: _ctx.resourceTypeOptions,
                                    label: _ctx.$t('admin-resources.filter.resourceType')
                                  }, null, 8 /* PROPS */, ["modelValue", "items", "label"])
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "4",
                                class: "d-flex align-center gap-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    onClick: _ctx.addFilterPropertyRow
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.addFilterProperty')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"]),
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    class: "ml-2",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.savedFiltersDialog = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.useExistingFilter')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createCommentVNode(" Lista propertiesów służących do filtrowania "),
                          _createVNode(_component_resource_properties_edit_component, {
                            allPropertiesDictionary: _ctx.searchPropertiesDictionary,
                            propertiesList: _ctx.resourceListFilter.properties
                          }, null, 8 /* PROPS */, ["allPropertiesDictionary", "propertiesList"]),
                          _createVNode(_component_v_row, { justify: "start" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    class: "mr-4",
                                    onClick: _ctx.listResources
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.search')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"]),
                                  _createVNode(_component_v_btn, {
                                    variant: "outlined",
                                    onClick: _ctx.clearFilters
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('admin-resources.filter.clear')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _createCommentVNode(" dialog z podglądem resource'a "),
                    (_ctx.resourcePreviewDialog)
                      ? (_openBlock(), _createBlock(_component_resource_preview_dialog, {
                          key: 0,
                          resourceId: _ctx.resourcePreviewId,
                          previewDialog: _ctx.resourcePreviewDialog,
                          previewSrc: _ctx.resourcePreviewSrc,
                          previewTitle: _ctx.resourcePreviewTitle,
                          onCloseDialog: _ctx.onCloseResourcePreview
                        }, null, 8 /* PROPS */, ["resourceId", "previewDialog", "previewSrc", "previewTitle", "onCloseDialog"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  "item.name": _withCtx(({ item }) => [
                    _createVNode(_component_v_tooltip, {
                      location: "top",
                      "open-delay": "500"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("div", _mergeProps(props, {
                          class: "text-wrap",
                          style: {"max-width":"500px"}
                        }), _toDisplayString(item.name), 17 /* TEXT, FULL_PROPS */)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-2",
                      onClick: ($event: any) => (_ctx.showResourcePreview(item))
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode(" mdi-chevron-right-circle-outline ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      size: "small",
                      class: "mr-2",
                      onClick: ($event: any) => (_ctx.copyIdToClipboard(item))
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode(" mdi-content-copy ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                  ]),
                  "item.modifiedTimestamp": _withCtx(({ item }) => [
                    _createElementVNode("span", null, _toDisplayString(new Date(item.modifiedTimestamp).toLocaleString(_ctx.currentLanguage)), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "headers", "items", "options", "items-length", "loading"])
              ])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, { class: "pt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              (!_ctx.dialogOptions.noconfirm)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    variant: "outlined",
                    onClick: _ctx.resolveCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('confirm-dialog.cancel')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_v_btn, {
                variant: "flat",
                color: "primary",
                onClick: _ctx.resolveSelectedResource
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('confirm-dialog.ok')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onKeydown"]))
}